import React, {useState} from 'react';
import styled from 'styled-components';
import Image from 'next/image';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: ${(props) => (props.isOpen ? '100%' : '0')};
  background-color: rgba(0, 0, 0, 0.9);
  transition: height 0.5s ease;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 30px;
  color: white;
  background: none;
  border: none;
  display: ${(props) => (props.isVisible ? 'block' : 'none')};
  cursor: pointer;
`;

const Thumbnail = styled(Image)`
  cursor: pointer;
`;

const YouTubePopup = ({thumbnail,url,title, height = '370px'}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');

    const openNav = (url) => {
        setVideoUrl(url);
        setIsOpen(true);
    };

    const closeNav = () => {
        setIsOpen(false);
        setVideoUrl('');
    };

    return (
        <div style={{width:'100%',height:height}}>
            <Thumbnail
                src={thumbnail?.url}
                alt={thumbnail?.alt ?? thumbnail?.name ?? title}
                width={500}
                height={500}
                onClick={() => openNav(url)}
                style={{
                    width:'100%',
                    height:'100%',
                    objectFit:'cover',
                }}
            />

            <Overlay isOpen={isOpen}>
                <CloseButton isVisible={isOpen} onClick={closeNav}>
                    &times;
                </CloseButton>
                {isOpen && (
                    <iframe
                        width="90%"
                        height="90%"
                        src={url}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                )}
            </Overlay>
        </div>
    );
};

export default YouTubePopup;
